<article class="about-walk-card" *ngIf="card">
  <p class="about-walk-card-icon" *ngIf="card.icon">{{ card.icon }}</p>
  <h3>{{ card.title }}</h3>
  <p class="about-walk-card-body">{{ card.body }}</p>
</article>
